import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useInstantSearch, useSortBy} from 'react-instantsearch'
import ApiService from "@bodeboca/api"
import Stats from "@bodeboca/algolia/components/search/stats"

const CustomSort = () => {
  const {t} = useTranslation()
  const items = ApiService.getSortOptions()
  const {options, refine, currentRefinement, initialIndex} = useSortBy({
    items: items,
  })
  useEffect(() => {
    let currentOption = options.find((element) => element['value'] === currentRefinement)
    if (currentOption) {
      setCurrent(currentOption)
    }
  }, [currentRefinement])

  function select(index: number) {
    const selected = options[index]
    setCurrent(selected)
    refine(selected['value'])
    setIsOpen(false)
  }

  const [isOpen, setIsOpen] = useState(false)
  const [current, setCurrent] = useState(ApiService.getDefaultSort())
  const {results} = useInstantSearch()
  const isHidden = () => {
    return results.hits.length === 0
  }

  return (<>

    <div className="bb-product-info-sort">
      <div>
        <Stats className={"nomobile"}/>
      </div>
      <div
        className={isHidden() ? "display-none" : "bb-product-sort"}
        id={'bb_product_sort'}>
        <div id="bb-sp-sort-form">
          <span
            className="bb-filter-labels sort-by-prefix"
            style={{display: 'block'}}
            onClick={(event) => {
              event.preventDefault()
              setIsOpen(!isOpen)
            }}>
            {t('Sort by')}
          </span>
          {!isOpen && <span
            className="icon bbicon-caret-down sort-dropdown-icon">
          </span>}
          {isOpen && <span className="icon bbicon-caret-up sort-dropdown-icon"></span>}
          <input
            className="form-button bb-filter-control jq-dropdown-open"
            style={{display: 'block'}}
            type="button"
            value={t(current['label'])}
            onClick={(event) => {
              event.preventDefault()
              setIsOpen(!isOpen)
            }}/>

          <div
            className={'jq-dropdown jq-dropdown-anchor-left ' + (isOpen ? 'sort-block' : 'sort-none')}
            style={isOpen ? {display: 'block'} : {display: 'none'}}>
            <div className="item-list">
              <ul className="jq-dropdown-menu">
                {items.map((item: any, index: number) => (<li
                  className={'first ' + (item.value !== current.value ? 'sort-block' : 'sort-none')}
                  key={item.value}
                  onClick={() => select(index)}>
                  <a className={'bb-sort-option-item'}>{t(item.label)}</a>
                </li>))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="clear"/>
    </div>
  </>)
}
export default CustomSort
